<fieldset [attr.aria-describedby]="helpText ? inputId + '-help' : null">
    @if (label) {
        <legend class="form-label mb-2">
            {{ label }}
        </legend>
    }
    <div class="colour-swatch-options">
        @for (colour of colours; track colour; let index = $index) {
            <div class="colour-swatch-option">
                <input
                    class="visually-hidden"
                    type="radio"
                    [name]="inputId"
                    [id]="optionId(index)"
                    [checked]="selectedColour === colour"
                    [attr.data-testid]="optionId(index)"
                    (change)="selectColour(colour)"
                >
                <label
                    class="colour-swatch"
                    [for]="optionId(index)"
                    [style.background-color]="colour"
                >
                    <span class="visually-hidden">
                        Colour option {{ index + 1 }}
                    </span>
                </label>
            </div>
        }
        @if (allowDefault) {
            <button
                class="btn btn-sm btn-outline-secondary"
                type="button"
                [attr.data-testid]="inputId + '-default'"
                [disabled]="selectedColour === null"
                (click)="selectColour(null)"
            >
                Use default
            </button>
        }
    </div>
    @if (helpText) {
        <div [id]="inputId + '-help'" class="form-text">
            {{ helpText }}
        </div>
    }
</fieldset>
